var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"match-list"},_vm._l((_vm.matchList),function(item,index){return _c('div',{key:index,staticClass:"item matchItem",on:{"click":function($event){return _vm.toMatchDetail(item)}}},[_c('match-plate',{attrs:{"item":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }